import React, { useEffect, useState } from "react";
import {
  View,
  Image,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
} from "react-native";
import { TReturnGetImagesBatchBatchId } from "../../../services/api";

type DisplayImageOneSquareProps = {
  currentImageData: TReturnGetImagesBatchBatchId[];
  isAIImages: boolean;
  isAllProcedureDataEmpty?: boolean;
};

const DisplayOneSquare = ({
  currentImageData,
  isAIImages,
  isAllProcedureDataEmpty = false,
}: DisplayImageOneSquareProps) => {
  const [selectedImageData, setSelectedImageData] =
    useState<TReturnGetImagesBatchBatchId | null>(null);
  const [imageData, setImageData] = useState<TReturnGetImagesBatchBatchId[]>(
    [],
  );

  useEffect(() => {
    let filteredData: TReturnGetImagesBatchBatchId[] = [];
    if (isAllProcedureDataEmpty) {
      filteredData = currentImageData;
    } else {
      filteredData = currentImageData.filter((item) =>
        item.uploadType.includes(isAIImages ? "Transform" : "Patient"),
      );
    }
    if (filteredData.length === 0) return;
    setImageData(filteredData);
    setSelectedImageData(filteredData[0]);
  }, [currentImageData, isAIImages, isAllProcedureDataEmpty]);

  if (imageData && imageData.length === 0) return null;

  return (
    <View style={styles.container}>
      <img
        style={styles.imageContainer}
        draggable={false}
        src={
          selectedImageData && selectedImageData.presignedUrls.length !== 0
            ? selectedImageData.presignedUrls[
                selectedImageData.presignedUrls.length - 1
              ]
            : ""
        }
        alt=""
      />
      <ScrollView
        horizontal
        style={{
          width: "100%",
        }}
        contentContainerStyle={{
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        {imageData.map((image, index) => (
          <TouchableHighlight
            key={index}
            onPress={() => setSelectedImageData(image)}
            underlayColor="#DDDDDD"
            style={{
              width: 90,
              aspectRatio: 1,
            }}
          >
            <Image
              style={[
                styles.imageSmall,
                image === selectedImageData && styles.selectedImageStyle,
              ]}
              source={{
                uri:
                  image && image.presignedUrls.length !== 0
                    ? image.presignedUrls[image.presignedUrls.length - 1]
                    : "",
              }}
            />
          </TouchableHighlight>
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
  },
  imageContainer: {
    display: "flex",
    flex: 1,
    width: "100%",
    height: "auto",
    objectFit: "contain",
    position: "relative",
  },
  fiveImagesContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
  imageSmall: {
    width: "100%",
    height: "100%",
    borderRadius: 10,
    borderWidth: 5,
    borderColor: "transparent",
  },
  selectedImageStyle: {
    borderColor: "#0000004D",
    // @ts-ignore comment
    filter: "brightness(0.8)",
  },
});

export default DisplayOneSquare;
